export default {"src":"/_next/static/media/verified.bb7d84a9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};